<template>
    <section class="w-full max-w-5xl px-4 py-8 mx-auto md:py-12 lg:py-24">
      <div
        class="text-xl font-bold text-center md:text-2xl lg:text-2xl xl:text-3xl xl:leading-10 font-ww-bold"
        v-html="heading"
      ></div>
  
      <div
        class="mt-6 text-center font-ww-light md:text-17 !leading-5"
        v-html="subText"
      ></div>
    </section>
  </template>
  
  <script setup>
  const props = defineProps({
    heading: {
      type: String,
      default: "Truly revolutionary coffee. You’ll love the taste to the last drop"
    },
    subText: {
      type: String,
      default: `Your cup of Lifeboost Premium Coffee comes from coffee beans that have been individually hand selected as the premium bean(s) of a harvest. Your coffee beans are lovingly cultivated by local farmers, after being grown slowly to full maturity in mountain shade.`
    }
  });
  
  defineBuilderComponent({
    friendlyName: "HeadingWhitText",
    inputs: [
      {
        name: "heading",
        type: "richText",
        friendlyName: "Heading",
        defaultValue: "Truly revolutionary coffee. You’ll love the taste to the last drop"
      },
      {
        name: "subText",
        type: "richText",
        friendlyName: "Subtext",
        defaultValue: `Your cup of Lifeboost Premium Coffee comes from coffee beans that have been individually hand selected as the premium bean(s) of a harvest. Your coffee beans are lovingly cultivated by local farmers, after being grown slowly to full maturity in mountain shade.`
      }
    ]
  });
  </script>
  